/**
 * Avatar utility functions for determining avatar display type
 * and generating fallback content.
 */

/**
 * Determines if an avatar string is an image source
 * (Firebase Storage URL or base64 data URI) vs an emoji.
 */
export function isImageAvatar(avatar: string | null | undefined): boolean {
    if (!avatar) return false;
    return (
        avatar.startsWith('http://') ||
        avatar.startsWith('https://') ||
        avatar.startsWith('data:image')
    );
}

/**
 * Get initials from a username for fallback display.
 */
export function getInitials(username?: string | null): string {
    if (!username) return '?';
    return username
        .split(/[\s_-]/)
        .map(w => w[0])
        .filter(Boolean)
        .slice(0, 2)
        .join('')
        .toUpperCase() || '?';
}
